export default __webpack_public_path__ + "static/media/grip-flat.ec60b099.svg";